import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("rifiuti_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function formatError(err) {
  const d = err?.response?.data?.detail;
  if (!d) return err?.message || "Errore imprevisto";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => e.msg || JSON.stringify(e)).join(" ");
  return JSON.stringify(d);
}

export const WASTE_TYPES = [
  { value: "carta", label: "Carta / Cartone", color: "#3b82f6" },
  { value: "plastica", label: "Plastica", color: "#eab308" },
  { value: "vetro", label: "Vetro", color: "#10b981" },
  { value: "metallo", label: "Metallo", color: "#6b7280" },
  { value: "umido", label: "Umido / Organico", color: "#84cc16" },
  { value: "indifferenziato", label: "Indifferenziato", color: "#71717a" },
  { value: "ingombranti", label: "Ingombranti", color: "#a855f7" },
  { value: "legno", label: "Legno", color: "#a16207" },
  { value: "raee", label: "RAEE", color: "#dc2626" },
];

export const wasteLabel = (v) => WASTE_TYPES.find((w) => w.value === v)?.label || v;
export const wasteColor = (v) => WASTE_TYPES.find((w) => w.value === v)?.color || "#6b7280";

export const STATUS_MAP = {
  pending: { label: "In attesa", cls: "bg-amber-100 text-amber-800 border-amber-200" },
  approved: { label: "Approvato", cls: "bg-emerald-100 text-emerald-800 border-emerald-200" },
  rejected: { label: "Contestato", cls: "bg-red-100 text-red-800 border-red-200" },
  recognized: { label: "Riconosciuto TARI", cls: "bg-blue-100 text-blue-800 border-blue-200" },
};
